import { Injectable } from '@angular/core';

@Injectable()
export class ErrorsService {

  public generic: string;
  public required: string;
  public numeric: string;
  public betweenDate: string;
  public email: string;

  constructor() {
    this.generic = 'Favor de verificar el tipo de dato introducido no es válido';
    this.required = 'Campo requerido';
    this.numeric = 'Solo se aceptan valores numéricos';
    this.betweenDate = 'Fecha no es válida';
    this.email = 'Favor de introducir un correo con el formato correcto';
  }

  between(min, max) {
    return 'El valor introducido debe de ser entre ' + min + ' y ' + max;
  }

  max(size) {
    return 'Se excedió la longitud del campo aceptada ' + size;
  }

  min(size: any) {
    return 'El campo no cumple la longitud aceptada: ' + size;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/tools/errors.service.ts